import { useSelector } from 'react-redux';
import * as Styled from '../../styles/UsuariosAprovados.styles';
import PropTypes from 'prop-types';
import formatMoney from '../../../../utils/functions/formatMoneyBRL';
import Information from '../../../../components/Information/InformationColum';
import { theme } from '../../../../styles/theme';

const { secondaryColor } = theme.colors;

export default function TaxCollum() {
  const { TAXAS } = useSelector((state) => state.user.usersData);

  const data = TAXAS?.map((taxa) => {
    switch (taxa.ID_TIPO_VALOR) {
      case '1':
        return {
          name: taxa.DESCRICAO,
          value: `R$ ${formatMoney(taxa.VALOR)}`,
        };
      case '2':
        return {
          name: taxa.DESCRICAO,
          value: `${formatMoney(taxa.VALOR)} %`,
        };
      default:
        return {
          name: taxa.DESCRICAO,
          value: `${parseInt(taxa.VALOR)}`,
        };
    }
  });

  return (
    <Styled.TaxaContainer>
      <Information
        title="Taxas Aplicadas"
        data={data}
        color={secondaryColor}
        bold={true}
      />
    </Styled.TaxaContainer>
  );
}
